import _defineProperty from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";
import * as types from "@/store/constants/types";

var Getters = _defineProperty({}, types.GETTER_INIT_IAP_STATUS, function (state, payLoad) {
  return state.initIapStatus;
});

export default Getters;